import React from 'react';
import PropTypes from 'prop-types';

import Modal from '../../../common/components/utils/Modal/Modal';
import withTranslations from '../../../common/components/utils/Translations/withTranslations';
import translatePropTypes from '../../../common/translatePropTypes';
import RestrictedOperationConfirmationForm from './RestrictedOperationConfirmationForm';
import Notifications from '../../../common/utils/Notifications';

const confirmationTypes = ['email', 'mobile'];

@withTranslations
export default class RestrictedOperationConfirmationContent extends React.Component {
  static propTypes = {
    pendingEmailConfirmation: PropTypes.bool.isRequired,
    activeConfirmationType: PropTypes.oneOf(confirmationTypes),
    activeConfirmationToken: PropTypes.string,
    baseRoute: PropTypes.string.isRequired,
    onCancel: PropTypes.func,
    onConfirm: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    updateMessageText: PropTypes.string,
    ...translatePropTypes,
  };

  static defaultProps = {
    activeConfirmationType: null,
    activeConfirmationToken: null,
    onCancel: null,
    updateMessageText: 'Updated Successfully',
  };

  constructor(props) {
    super(props);
    this.state = {
      formValues: {
        confirmationType: props.activeConfirmationType,
        confirmationToken: props.activeConfirmationToken,
      },
    };
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const {
      formValues: { confirmationType, confirmationToken },
    } = prevState;
    const {
      activeConfirmationType: nextConfirmationType,
      activeConfirmationToken: nextConfirmationToken,
    } = nextProps;

    if (
      confirmationToken === nextConfirmationToken &&
      confirmationType === nextConfirmationType
    ) {
      return null;
    }

    return {
      formValues: {
        confirmationType: nextConfirmationType,
        confirmationToken: nextConfirmationToken,
      },
    };
  }

  componentDidMount() {
    this.updateRoute();
  }

  componentDidUpdate() {
    this.updateRoute();
  }

  getNormalizedActiveConfirmationType() {
    const { activeConfirmationType } = this.props;

    if (confirmationTypes.includes(activeConfirmationType)) {
      return activeConfirmationType;
    }

    return null;
  }

  nextConfirmationType() {
    const { pendingEmailConfirmation } = this.props;

    if (pendingEmailConfirmation) {
      return 'email';
    }

    return null;
  }

  updateRoute() {
    const {
      history,
      history: {
        location: { pathname: currentRoute },
      },
      baseRoute,
    } = this.props;

    const activeConfirmationType = this.getNormalizedActiveConfirmationType();
    const nextConfirmationType = this.nextConfirmationType();

    if (!nextConfirmationType && baseRoute !== currentRoute) {
      // eslint-disable-next-line no-console
      history.replace(`${baseRoute}`);
    } else if (
      (!activeConfirmationType && nextConfirmationType) ||
      activeConfirmationType !== nextConfirmationType
    ) {
      // eslint-disable-next-line no-console
      history.replace(`${baseRoute}/confirm/${nextConfirmationType}`);
    }
  }

  handleConfirmation = async ({ confirmationType, confirmationToken }) => {
    const { onConfirm, updateMessageText, t } = this.props;
    const { pendingEmailConfirmation } = await onConfirm({
      emailConfirmationToken:
        (confirmationType === 'email' && confirmationToken) || null,
    });
    if (!pendingEmailConfirmation) {
      Notifications.success(t(updateMessageText), '', t);
    }
  };

  handleCancel = () => {
    const { history, baseRoute, onCancel } = this.props;
    if (onCancel) {
      onCancel();
    }
    // eslint-disable-next-line no-console
    history.replace(`${baseRoute}`);
  };

  render() {
    const { t, activeConfirmationType } = this.props;
    const { formValues } = this.state;

    return (
      <Modal
        size="sm"
        title={t('This operation requires confirmation')}
        visible={!!activeConfirmationType}
        onClose={this.handleCancel}
      >
        <RestrictedOperationConfirmationForm
          initialValues={formValues}
          onSubmit={this.handleConfirmation}
        />
      </Modal>
    );
  }
};
